export const GET_STUDENT_REG_COURSES = "GET_STUDENT_REG_COURSES";